import React from 'react';
import PropTypes from 'prop-types';
import { converter } from '../../../helpers/converter';
import { connect } from 'react-redux';
import { GetRegion } from '../../../constants';

class ButtonsRentForm extends React.Component {
  componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const params = {};
    for (const [key, value] of queryParams.entries()) {
      params[key] = value;
    }
    this.urlParams = params;
  }

  abortButton(event) {
    if (this.props.onClickBack !== undefined) {
      {
        this.props.onClickBack(event);
      }
      return;
    }

    if (this.urlParams.group_id) {
      if (this.urlParams.genero)
        window.location =
          `/${GetRegion()}/vcard/` +
          `homeuser` +
          `/${this.urlParams.genero}/${this.urlParams.group_id}`;
      else window.history.back();
    } else {
      window.location = '/';
    }
  }

  render() {
    let waitingGiftClass = '';
    let buttonContinueClass = '';
    let buttonContinueText = '';
    if (this.props.waitingResponse) {
      // Disable button and show loading gift
      waitingGiftClass = 'full-width padding-2';
      buttonContinueClass = 'btn btn-primary btn-lg btn-block disabled';
      buttonContinueText = this.props.loadingButtonText;
    } else {
      waitingGiftClass = 'full-width padding-2 hide';
      buttonContinueClass = 'btn btn-primary btn-lg btn-block';
      if (this.props.isPromocionJC) {
        buttonContinueText = !this.props.isPromocionJC
          ? converter.convertApaUnicode(
              this.props.translations,
              'medio_de_pago_siguiente',
            )
          : converter.convertApaUnicode(
              this.props.translations,
              'registro_aceptar',
            );
      }
      buttonContinueText = converter.convertApaUnicode(
        this.props.translations,
        'medio_de_pago_siguiente',
      );
    }

    let promo;
    let loading;
    if (this.props && this.props.isPromocionJC) {
      promo = 'promo--button col-xs-12';
      loading = 'col-lg-12 col-md-12 col-sm-12 col-xs-12';
    } else {
      promo = this.props.confirmBlockClassName;
      loading = this.props.loadingBlockClassName;
    }

    buttonContinueClass += this.props.pincode ? ' active ' : '';

    return (
      <div className={this.props.buttonsRentBlockClassName}>
        {/* Div de gift Cargando */}
        <div className={loading}>
          <span id="cargando" className={waitingGiftClass}>
            <img
              className="center-block"
              src="https://clarovideocdn0.clarovideo.net/fe/sitesplus/sk_core/images/cargando.gif"
              width="54"
            />
          </span>
        </div>

        {/* Div de boton volver */}
        {!this.props.isPromocionJC && (
          <div
            className={this.props.backBlockClassName}
            onClick={this.abortButton.bind(this)}
          >
            <div className="form-group">
              <a className="btn btn-default btn-lg btn-block">
                {this.props.backButtonText}
              </a>
            </div>
          </div>
        )}

        {/* Div de boton Confirmar */}

        <div className={promo}>
          <input
            type="submit"
            id="btnSiguiente"
            className={buttonContinueClass}
            value={buttonContinueText}
            onClick={this.props.onClickConfirm}
          />
        </div>
      </div>
    );
  }
}

ButtonsRentForm.defaultProps = {
  buttonsRentBlockClassName: '',
  loadingBlockClassName: 'col-lg-6 col-md-6 col-xs-12 col-sm-12',
  backBlockClassName: 'col-lg-3 col-md-3 col-sm-6',
  confirmBlockClassName: 'col-lg-3 col-md-3 col-sm-6',
  backButtonText: 'Volver',
  confirmButtonText: 'Siguiente',
  acceptButtonText: 'Aceptar',
  loadingButtonText: 'Cargando...',
};

ButtonsRentForm.propTypes = {
  translations: PropTypes.object.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
  waitingResponse: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  router: state.routing,
  translations: state.translations,
});

export default connect(mapStateToProps)(ButtonsRentForm);
